import { createSelector } from "reselect";

import { AppState } from "../interfaces";

const selectShared = (state: AppState) => state.shared;

export const selectRouter = () =>
  createSelector(
    (state: AppState) => state,
    (state) => state,
  );

export const getLoading = () => createSelector(selectShared, (state) => state.loading);

export const getNotification = () => createSelector(selectShared, (state) => state.notification);

export const getModal = () => createSelector(selectShared, (state) => state.modal);

export const getOverlay = () => createSelector(selectShared, (state) => state.overlay);

export const getSidebar = () => createSelector(selectShared, (state) => state.sidebar);

export const getRoles = () => createSelector(selectShared, (state) => state.roles);

export const getPermissions = () => createSelector(selectShared, (state) => state.permissions);

export const getUserDetails = () => createSelector(selectShared, (state) => state.user);

export const getLoadingSections = () => createSelector(selectShared, (state) => Object.keys(state.loadingSections));

export const getLoadingSection = (sectionName: string) =>
  createSelector(selectShared, (state) => state.loadingSections[sectionName]);

export const getNavigateURL = () => createSelector(selectShared, (state) => state.navigateURL);
